import moment from 'moment'
import { FC } from 'react'
import { DateFormatMoment } from 'utils/date'
import { useI18n } from 'utils/localisation'

import { SailingSchedule } from '../SailingSchedule'
import { Description } from './Description'
import { TransportTime } from './TransportTime'

interface SailingDescriptionsProps {
  sailing: SailingSchedule
}

export const SailingDescriptions: FC<SailingDescriptionsProps> = ({ sailing }) => {
  const { translate } = useI18n()
  return (
    <div>
      <Description
        time={
          <TransportTime
            preLabel={translate('quote_sheet-option-transport_plan-ETD')}
            time={moment(sailing.etd).format(DateFormatMoment.DATE)}
          />
        }
        label={translate('quote_sheet-option-transport_plan-POL')}
        text={sailing.pol.name}
      />

      {sailing.oceanLegs.map((leg, i) => {
        const isLastLeg = i === sailing.oceanLegs.length - 1

        // The POD of the last leg we get from Big Schedule is not always equal to the final POD
        // e.g last leg POD is "DEWVN" while the final POD is "DEHAM"
        // -> There's an "invisible" leg from DEWVN to DEHAM carried out by truck or barge or whatever (not provided by carrier)
        // In this case, display whatever pod_id is on the last leg. Else, display the port name

        const legPodName: string = (leg.pod && leg.pod.name) || leg.pod_id
        const portName: string = isLastLeg && sailing.pod._id === leg.pod_id ? sailing.pod.name : legPodName

        return (
          <div key={i}>
            <Description
              time={<span />}
              label={translate('quote_sheet-option-transport_plan-vessel')}
              text={leg.vessel.name}
              invertBg
            />
            <Description
              time={
                <div>
                  <TransportTime
                    preLabel={translate('quote_sheet-option-transport_plan-ETA')}
                    time={moment(leg.eta).format(DateFormatMoment.DATE)}
                  />
                </div>
              }
              label={
                sailing.oceanLegs.length - 1 > i
                  ? translate('quote_sheet-option-transport_plan-transshipment_port')
                  : translate('quote_sheet-option-transport_plan-port_of_discharge')
              }
              text={portName}
              invertBg
            />
          </div>
        )
      })}
    </div>
  )
}
